module.exports = __webpack_public_path__ + "media/images/app_store-9eadb2de.svg";